/**
 * @typedef {{
 *     value: string,
 *     label: string
 * }} AiAnnouncementOption
 */

/** @type {AiAnnouncementOption[]} */
export const riskOptions = [
    { value: 'minimal', label: 'Minimal' },
    { value: 'limited', label: 'Begrenzt (Art. 50)' },
    { value: 'high-risk', label: 'High-Risk (Annex III)' },
    { value: 'prohibited', label: 'Verboten (Art. 5)' },
    { value: '', label: 'Unklar' },
];

/** @type {AiAnnouncementOption[]} */
export const riskFullOptions = [...riskOptions];

/** @type {AiAnnouncementOption[]} */
export const roleOptions = [
    { value: 'deployer', label: 'Betreiber (Deployer)' },
    { value: 'provider', label: 'Anbieter (Provider)' },
    { value: 'distributor', label: 'Distributor / Importer' },
];

/** @type {AiAnnouncementOption[]} */
export const roleFullOptions = [...roleOptions, { value: '', label: 'Unbekannt' }];

/** @type {AiAnnouncementOption[]} */
export const humanOversightOptions = [
    { value: 'in', label: 'Human-in-the-Loop' },
    { value: 'on', label: 'Human-on-the-Loop' },
    { value: 'out', label: 'Human-out-of-the-Loop' },
];

/** @type {AiAnnouncementOption[]} */
export const humanFullOversightOptions = [...humanOversightOptions, { value: '', label: 'Unbekannt' }];
